import { getDb } from "./core";
import { META_SYNC_SEQ_KEY } from "./types";

export async function loadLastSyncedSeq(): Promise<number> {
  const db = await getDb();
  const row = await db.get("meta", META_SYNC_SEQ_KEY);
  if (!row || !("value" in row) || typeof row.value !== "number" || !Number.isFinite(row.value)) {
    return 0;
  }
  return Math.max(0, row.value);
}

export async function saveLastSyncedSeq(seq: number): Promise<void> {
  const db = await getDb();
  await db.put("meta", { value: Math.max(0, Math.floor(seq)) }, META_SYNC_SEQ_KEY);
}

export async function advanceLastSyncedSeq(seq: number): Promise<number> {
  const nextSeq = Math.max(0, Math.floor(seq));
  const db = await getDb();
  const tx = db.transaction("meta", "readwrite");
  const row = await tx.store.get(META_SYNC_SEQ_KEY);
  const current =
    row && "value" in row && typeof row.value === "number" && Number.isFinite(row.value) ? row.value : 0;
  const merged = Math.max(current, nextSeq);
  await tx.store.put({ value: merged }, META_SYNC_SEQ_KEY);
  await tx.done;
  return merged;
}
